export default {
  fieldNames: {
    operationalAreaSelected: 'Área operacional',
    equipmentGroupSelected: 'Tipo de Agrupación',
    groupReferenceSelected: 'Grupo Referencia',
    equipmentReferenceSelected: 'Equipo Referencia',
    componentCodeSelected: 'Código componente',
    installedQuantity: 'Cantidad instalada',
  },
  group: "Grupo",
  equipment: "Equipo",
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/cataloger/createNewMaterials/Stages/equipment-group-APL.js